import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateCallRailIntegration as UpdateCallRailIntegrationMutation,
    UpdateCallRailIntegrationVariables,
    CallRailIntegrationUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_CALL_RAIL_INTEGRATION from '../mutations/update-callrail-integration.graphql';

export const useUpdateCallRailIntegration = (): {
    updateCallRailIntegration: (arg1: CallRailIntegrationUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateCallRailIntegration, {loading, error}] = useMutation<
        UpdateCallRailIntegrationMutation,
        UpdateCallRailIntegrationVariables
    >(UPDATE_CALL_RAIL_INTEGRATION);

    return {
        updateCallRailIntegration: (input: CallRailIntegrationUpdateInput) =>
            updateCallRailIntegration({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
